export function canSwitchMode(mode) {
    return true;
}
//# sourceMappingURL=view-mode.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-bootstrap/datepicker/engine/view-mode.js
// module id = ../../../../ngx-bootstrap/datepicker/engine/view-mode.js
// module chunks = 7